// extracted by css-extract-rspack-plugin
export default {"EmbedPreviewIframe":"eeM9k","Container":"mx2A6","ResizeHandle":"TZhW4","Sidebar":"cAFIj","SidebarContent":"YuqBq","Navigation":"UIGq9","PreviewPanel":"TklSu"};